/*! Oruga v0.8.12 | MIT License | github.com/oruga-ui/oruga */
const isClient = typeof window !== "undefined";
const isSSR = typeof window === "undefined";
export {
  isSSR as a,
  isClient as i
};
//# sourceMappingURL=ssr-BtcosYqY.mjs.map
